import React, { Component } from 'react';

import { Card, CardTitle, CardText, CardActions } from 'react-mdl/lib/Card';
import Button from 'react-mdl/lib/Button';

class Login extends Component {
    errorMessage() {
        if (this.props.error) {
            return (
                <CardText style={{fontWeight: 'bold'}}>
                    Failed to login: {this.props.error}
                </CardText>
            )
        }
    }

    render() {
        return (
            <Card shadow={0} style={{width: '512px', margin: 'auto', position: 'absolute', left: '50%', top: '40%', transform: 'translateY(-50%) translateX(-50%'}}>
                <CardTitle>Welcome to 138th EVAN Scouter's Portal</CardTitle>
                {this.errorMessage()}
                <CardText>
                    Click below to login.
                </CardText>
                <CardText>
                    If you require but do not have access, send an email to <a href="mailto:steve.lam@scout138.com">Steve</a>.
                </CardText>
                <CardActions border>
                    <Button colored onClick={() => this.props.login()}>Login via Google</Button>
                </CardActions>
            </Card>
        );
    }
}

export default Login;



/** WEBPACK FOOTER **
 ** ./src/Login/Login.js
 **/